var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo, useState } from 'react';
import { CFButton } from '../../components';
import { commonAttrs } from '../../utils';
export const CFToggleButton = (_a) => {
    var { alternateTheme, children, iconLeft, iconLeftSelected, iconRight = null, iconRightSelected = 'checkmark', onSelect, selected = false, value, variant = 'primary' } = _a, rest = __rest(_a, ["alternateTheme", "children", "iconLeft", "iconLeftSelected", "iconRight", "iconRightSelected", "onSelect", "selected", "value", "variant"]);
    const [isSelected, setIsSelected] = useState(selected || false);
    const onClick = () => {
        setIsSelected((val = false) => {
            if (onSelect)
                onSelect({ selected: !val, value });
            return !val;
        });
    };
    const getVariant = () => {
        if (isSelected) {
            switch (variant) {
                case 'boost':
                    return alternateTheme ? 'boost-alternate' : 'boost';
                case 'subtle':
                    return alternateTheme ? 'control-active-alternate' : 'control-active';
                case 'primary':
                default:
                    return alternateTheme ? 'primary-alternate' : 'primary';
            }
        }
        return alternateTheme ? 'control-alternate' : 'control';
    };
    const getIconLeft = () => {
        if (isSelected) {
            if (iconLeftSelected === null)
                return undefined;
            if (iconLeftSelected)
                return iconLeftSelected;
            if (iconLeft === null)
                return undefined;
            if (iconLeft)
                return iconLeft;
            return undefined;
        }
        if (iconLeft === null)
            return undefined;
        if (iconLeft)
            return iconLeft;
        return undefined;
    };
    const getIconRight = () => {
        if (isSelected) {
            if (iconRightSelected === null)
                return undefined;
            if (iconRightSelected)
                return iconRightSelected;
            if (iconRight === null)
                return undefined;
            if (iconRight)
                return iconRight;
            return undefined;
        }
        if (iconRight === null)
            return undefined;
        if (iconRight)
            return iconRight;
        return undefined;
    };
    useMemo(() => {
        if (selected !== isSelected)
            setIsSelected(selected);
    }, [selected]);
    return (React.createElement(CFButton, Object.assign({ iconLeft: getIconLeft(), iconRight: getIconRight(), onClick: onClick, rounded: true, variant: getVariant() }, commonAttrs(rest)), children));
};
